/**
* @file Route: products
*
* This file is compiled as a standalone entrypoint and it is included by
* default in its blade template.
* This is a "standard" route, it does not have a structure to follow, you are
* sure the DOM is always ready and the JS will only be executed in this route.
*/

import "layouts/main";
import "components/Title";
import "components/VisualText";
import { CardProduct, CardProductProps } from "components/CardProduct";
import { Filters } from "components/Filters";
import { Products } from "components/Products";
import { datalayerProd } from "components/Datalayer";
import { replaceFragment } from "@olmokit/core/fragments";
import { FormType } from "components/Form";
import "components/Related";
import "./index.scss";

console.log("Route products/index.js mounted.");

replaceFragment("contactForm", "components.FormType").then(() => FormType());

CardProduct();
CardProductProps();
Filters('filters');
Products();

document.addEventListener('click',function(e){
    // console.dir(e.target);
    if (e.target.classList.contains('gtm-minimal')) {
        // push to datalayer
        dataLayer.push({
            'event': 'product_click',
            'product': e.target.getAttribute('data-product'),
            'product_size': e.target.getAttribute('data-size'),
            'product_finish': e.target.getAttribute('data-finish'),
            'product_thickness': e.target.getAttribute('data-thickness'),
            'product_specifications': 'false',
            'renderings': 'false',
        });
    }
    if (e.target.classList.contains('gtm-prodtitle')) {
        datalayerProd(e.target.getAttribute('data-product'), 'false', 'false');
    }
});